import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

import { Button } from '../../components/Button'
import { Card } from '../../components/Card'
import { useAuth } from '../../lib/auth'
import { registryApi } from '../../lib/api'

type Reg = { id: string; slug: string; status: 'draft' | 'published'; title: string }

function StatusBadge({ status }: { status: Reg['status'] }) {
  const published = status === 'published'
  return (
    <span
      style={{
        display: 'inline-block',
        padding: '2px 8px',
        borderRadius: 6,
        background: published ? '#cfe5d4' : '#eee5d2',
        color: published ? '#2d6a3e' : '#7d6427',
        fontWeight: 600,
        fontSize: 12,
      }}
    >
      {published ? 'Publiée' : 'Brouillon'}
    </span>
  )
}

export default function Dashboard() {
  const auth = useAuth()
  const [regs, setRegs] = useState<Reg[] | null>(null)

  useEffect(() => {
    registryApi
      .list()
      .then(setRegs)
      .catch(() => setRegs([]))
  }, [])

  const me = auth.status === 'authenticated' ? auth.me : null

  return (
    <main style={{ maxWidth: 1080, margin: '0 auto', padding: '2rem 1rem' }}>
      <header
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '2rem',
          gap: 12,
          flexWrap: 'wrap',
        }}
      >
        <h1 style={{ fontFamily: 'var(--font-heading)', margin: 0 }}>Mes listes</h1>
        <div style={{ display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap' }}>
          <Link to="/me/account" style={{ textDecoration: 'none' }}>
            <Button variant="ghost">Mon compte</Button>
          </Link>
          <Link to="/me/new" style={{ textDecoration: 'none' }}>
            <Button>Créer une nouvelle liste</Button>
          </Link>
        </div>
      </header>

      {regs === null && <p>Chargement…</p>}

      {regs && regs.length === 0 && (
        <Card>
          <h2 style={{ fontFamily: 'var(--font-heading)', marginTop: 0 }}>
            Bienvenue {me?.user.displayName ?? me?.user.email}
          </h2>
          <p style={{ color: 'var(--muted)' }}>
            Vous n'avez pas encore de liste. Créez la vôtre en 30 secondes.
          </p>
          <Link to="/me/new" style={{ textDecoration: 'none' }}>
            <Button>Créer ma première liste</Button>
          </Link>
        </Card>
      )}

      {regs && regs.length > 0 && (
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))',
            gap: 16,
          }}
        >
          {regs.map((r) => (
            <Card key={r.id}>
              <div style={{ display: 'flex', justifyContent: 'space-between', gap: 12 }}>
                <h2 style={{ marginTop: 0, fontFamily: 'var(--font-heading)' }}>{r.title}</h2>
                <StatusBadge status={r.status} />
              </div>
              <div style={{ marginTop: 12 }}>
                <Link to={`/me/r/${r.id}`} style={{ textDecoration: 'none' }}>
                  <Button variant="secondary">Gérer</Button>
                </Link>
              </div>
            </Card>
          ))}
        </div>
      )}
    </main>
  )
}
